import { render, staticRenderFns } from "./AdvancesModuleComponent.vue?vue&type=template&id=12886272&scoped=true"
import script from "./AdvancesModuleComponent.vue?vue&type=script&lang=js"
export * from "./AdvancesModuleComponent.vue?vue&type=script&lang=js"
import style0 from "./AdvancesModuleComponent.vue?vue&type=style&index=0&id=12886272&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12886272",
  null
  
)

export default component.exports